import styled from '@emotion/styled';
import { gsap } from 'gsap';
import { useState, useLayoutEffect, useRef } from 'react';

import { animateSVGPath } from '@components/Sections/utils/animations';
import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const TitlePenOutline: React.FC = () => {
  const [titlePenOutlinePathLength, setTitlePenOutlinePathLength] = useState(0);
  const titlePenOutlineRef = useRef<SVGPathElement | null>(null);

  useLayoutEffect(() => {
    const titlePenOutlineEl = titlePenOutlineRef.current;

    if (!titlePenOutlineEl) {
      return;
    }

    const ctx = gsap.context(() => {
      const penPathLength = titlePenOutlineEl.getTotalLength();
      setTitlePenOutlinePathLength(penPathLength);
      animateSVGPath({
        animationTarget: titlePenOutlineEl,
        animationTrigger: titlePenOutlineEl,
        animationStartPositions: 'top 30%',
        pathLength: penPathLength,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <PenOutline
      isFullCentered
      width="364"
      height="121"
      viewBox="0 0 364 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M306.985 93.4628C369.829 113.959 366.309 61.9205 359.334 41.7521C340.051 -6.52561 237.215 1.49961 174.191 1.49961C77.3381 8.39124 -5.14934 7.04791 1.3609 62.9078C16.5261 152.18 275.952 112.331 310.036 103.553C335.348 97.0341 351.231 84.3783 353.036 79.9039"
        stroke="#D9FC51"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        strokeDasharray={`${titlePenOutlinePathLength} ${titlePenOutlinePathLength}`}
        ref={titlePenOutlineRef}
      />
    </PenOutline>
  );
};

const PenOutline = styled(PenLine)`
  top: 54%;
  width: 340px;

  ${getMediaqueryStyled('xl')} {
    top: 50%;
    width: 237px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 174px;
  }

  ${getMediaqueryStyled('md')} {
    width: 159px;
  }
`;
